/** Sempro/sidang/penelitian request live queries. */

import { COL } from '../../collections';
import { where, orderBy } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { RequestDoc } from '../../types';

export function useRequestsFor(skripsiId: string | null) {
  return useLiveQuery<RequestDoc>(
    skripsiId ? COL.requests : null,
    skripsiId ? [where('skripsiId', '==', skripsiId), orderBy('createdAt', 'desc')] : [],
    Boolean(skripsiId),
  );
}

export function usePendingRequests() {
  return useLiveQuery<RequestDoc>(COL.requests, [
    where('status', '==', 'pending'),
    orderBy('createdAt', 'desc'),
  ]);
}

/** Every request across all statuses, newest first (request inbox). */
export function useAllRequests() {
  return useLiveQuery<RequestDoc>(COL.requests, [orderBy('createdAt', 'desc')]);
}
